import styled from 'styled-components';

export const CalendarMenuSC = styled.div<{ position?: 'left' | 'right' }>`
  display: flex;
  flex-direction: column;
  flex: 1;

  padding: 40px;
  position: relative;
  background: white;
  box-shadow: 0 2px 15px rgba(51, 61, 108, 0.1);
  border-radius: 24px;

  .title-container {
    .clickable {
      &:hover {
        text-decoration: underline;
      }

      cursor: pointer;
    }
  }

  .content {
    margin-top: 25px;

    .description-title,
    .description {
      opacity: 0.5;
    }

    .description-title {
      margin-top: 25px;
      margin-bottom: 8px;
    }
  }
`;
